require('../libs/aws-sdk-browser.js');
var AWS = window.AWS;
var tool = require('../tool');
var isFunction = tool.isFunction;
var noop = tool.noop;
var dataService = require('../dataService');
var replaceAWSPath = tool.replaceAWSPath;
var hasResourceCallback = tool.hasResourceCallback;
var logger = require('../logger');

function initSDK(region) {
    return dataService.assumerole(region).then(function (data) {
        var authConfig = {
            region: region,
            accessKeyId: data.Credentials.AccessKeyId,
            secretAccessKey: data.Credentials.SecretAccessKey,
            sessionToken: data.Credentials.SessionToken,
        };
        AWS.config.update(authConfig);
    });
}

function getUploadObj(params) {
    var ext = params.ext;
    var id = params.id;
    var obj = Object.assign(
        {
            id: id,
            media_type: '',
            ext: ext,
        },
        params
    );

    return dataService.getUploadObj(obj);
}

/**
 * 创建分片上传示例
 * @param {*} file
 * @param {*} options
 */
var PartialUploader = function (file, options, callback) {
    this.file = file;
    this.ext = file.name.split(/\./g).pop();
    this.key = '';
    this.bucket = '';
    this.client = null;
    this.payLoadData = {}; //传给服务器的真实地址
    this.uploadedParts = [];
    this.uploadId = '';
    this.options = options;
    var that = this;

    options = Object.assign(
        {
            success: noop,
            error: noop,
        },
        options
    );
    var ext = file.name.split(/\./g).pop();

    // 分配角色
    var mediaType = options.signature.media_type;
    getUploadObj({
        id: options.signature.id,
        id_prefix: options.signature.id_prefix || 'teacher',
        media_type: mediaType,
        ext: ext,
    }).then(function (data) {
        logger.log('[umu-upload aws]  getUploadObj', data);
        initSDK(data.region).then(function () {
            var resourceId = data.resource_id;
            that.resourceId = data.resource_id;
            that.payLoadData.resource_id = resourceId;

            // 将isCustomEndpoint挂载到window上，用于判断是否是自定义的endpoint, 方便在aws的sdk中使用
            window.isCustomEndpoint = parseInt(data.enable_new_bucket, 10) === 1;
            var customEndpoint = window.isCustomEndpoint ? tool.getURLOriginFromURLString(data.aws_url) : undefined;

            var s3Params = {
                params: { Bucket: data.bucket || '' },
            };
            if (window.isCustomEndpoint && customEndpoint) {
                s3Params.endpoint = customEndpoint;
            }

            var s3 = new AWS.S3(s3Params);

            that.client = s3;
            that.key = data.path;
            that.bucket = data.bucket;

            var mimeType = tool.getMimeType(file);
            var createMultipartParams = {
                Key: that.key,
                ContentType: mimeType,
            };

            that.client.createMultipartUpload(createMultipartParams, function (mpErr, multipart) {
                if (mpErr) {
                    logger.error('[umu-upload aws]  createMultipartUpload error: ', mpErr);
                    if (isFunction(callback)) {
                        callback.apply(null, [mpErr]);
                    }

                    return;
                }

                that.uploadId = multipart.UploadId;
                if (isFunction(callback)) {
                    callback.apply(null, [null, that.uploadId]);
                }
            });
        });
    });
};

/**
 * 分片上传
 * @param {*} partNumber
 * @param {*} partSize
 * @param {*} blob
 * @param {*} callback
 */
PartialUploader.prototype.uploadPartFile = function (partNumber, _, blob, callback) {
    var retryTimes = 0;
    var maxRetryTimes = 5;
    var that = this;

    var partParams = {
        Body: blob,
        Key: that.key,
        PartNumber: partNumber,
        UploadId: that.uploadId,
    };

    var reuploadWhenNetworkConnected = function () {
        uploadPartFromBlob();
        window.removeEventListener('online', reuploadWhenNetworkConnected);
    };

    var uploadPartFromBlob = function () {
        that.client.uploadPart(partParams, function (err, resp) {
            logger.log('[umu-upload aws] uploadPart', err, resp);
            if (err) {
                logger.error('[umu-upload aws] uploadPart error', err, that.uploadId);
                if (!navigator.onLine) {
                    logger.error('[umu-upload aws] uploadPart network disconnected');
                    window.addEventListener('online', reuploadWhenNetworkConnected);
                    return;
                }

                if (retryTimes >= maxRetryTimes) {
                    if (isFunction(callback)) {
                        callback.apply(null, [err]);
                    }
                } else {
                    setTimeout(function () {
                        retryTimes += 1;
                        uploadPartFromBlob();
                    }, ((retryTimes % 2) + 2) * 1000);
                }
                logger.error('[umu-upload aws] retryTimes', retryTimes);
                return;
            }

            var partResult = {
                PartNumber: partParams.PartNumber,
                ETag: resp.ETag,
            };

            // uploadedParts对象已经被销毁，不进行push
            if (!that.uploadedParts) {
                // logger.error('[umu-upload aws] uploadedParts is null', resp);
                return;
            }

            var existedPartIndex = -1;
            for (var i = 0; i < that.uploadedParts.length; i++) {
                if (that.uploadedParts[i].PartNumber === partResult.PartNumber) {
                    existedPartIndex = i;
                    break;
                }
            }

            // 删除已有的partNumber的分片
            if (existedPartIndex > -1) {
                that.uploadedParts.splice(existedPartIndex, 1);
            }

            that.uploadedParts.push(partResult);
            if (isFunction(callback)) {
                callback.apply(null, [null, resp]);
            }
        });
    };

    uploadPartFromBlob();
};

/**
 * 各个分片上传结束后拼接分片
 * @param {*} callback
 * @returns
 */
PartialUploader.prototype.completeMultipartUpload = function (callback) {
    // 将分片数据按照PartNumber从小到大进行排序
    var sortedParts = this.uploadedParts.sort(function (a, b) {
        return parseInt(a.PartNumber, 10) - parseInt(b.PartNumber, 10);
    });

    var doneParams = {
        Key: this.key,
        MultipartUpload: { Parts: sortedParts },
        UploadId: this.uploadId,
    };

    var that = this;

    return this.client.completeMultipartUpload(doneParams, function (err, data) {
        logger.log('[umu-upload aws] completeMultipartUpload', err, data);
        if (err) {
            logger.error('[umu-upload aws] completeMultipartUpload error', err);
            if (isFunction(callback)) {
                callback.apply(null, [err]);
            }
            return;
        }

        if (!that.payLoadData) {
            logger.error('[umu-upload aws] completeMultipartUpload error, payLoadData is null', that.uploadId);
            if (isFunction(callback)) {
                callback.apply(null, [new Error('uploadCallback: payLoadData is null')]);
            }
            return;
        }

        if (!data.Location) {
            if (isFunction(callback)) {
                callback.apply(null, [new Error('uploadCallback: path is empty')]);
            }
            return;
        }

        that.payLoadData.path = replaceAWSPath(decodeURIComponent(data.Location));

        if (isFunction(callback)) {
            callback.apply(null, [null, data]);
        }
    });
};

/**
 * 取消分片上传
 * @param {*} callback
 * @returns
 */
PartialUploader.prototype.abortMultipartUpload = function (callback) {
    var abortParams = {
        Bucket: this.bucket,
        Key: this.key,
        UploadId: this.uploadId,
    };
    return this.client.abortMultipartUpload(abortParams, function (err, data) {
        if (err) {
            logger.error('[umu-upload aws] abortMultipartUpload error', err);
            if (isFunction(callback)) {
                callback.apply(null, [err]);
            }
            return;
        }

        if (isFunction(callback)) {
            callback.apply(null, [null, data]);
        }
    });
};

/**
 * 分片上传且拼接完成后的回调保存总体的文件并转码保存到资料库
 * @param {*} targetExt
 * @param {*} callback
 * @returns
 */
PartialUploader.prototype.uploadCallback = function (targetExt, fileSize, callback, extendInfo) {
    var mediaType = this.options.signature.media_type;
    if (!this.payLoadData.path || !hasResourceCallback(mediaType)) {
        if (isFunction(callback)) {
            return Promise.resolve().then(function () {
                callback.apply(null, [new Error('uploadCallback: path is empty')]);
            });
        }
        return;
    }

    var that = this;

    var params = {
        media_type: mediaType,
        resource_id: this.payLoadData.resource_id,
        file_name: this.file.name,
        file_size: fileSize,
        path: this.payLoadData.path,
        ext: targetExt || 'mp4',
        extend_info: extendInfo,
    };

    var ext = params.ext;

    return dataService
        .uploadCallback(
            Object.assign(
                {
                    media_type: '',
                    sp: 2,
                    ext: ext,
                },
                params
            )
        )
        .then(function () {
            if (isFunction(callback)) {
                callback.apply(null, [null, that.payLoadData]);
            }

            that.client.removeAllListeners();
        })
        .catch(function (err) {
            logger.error('[umu-upload aws] uploadCallback error', err);
            if (isFunction(callback)) {
                callback.apply(null, [err]);
            }

            that.client.removeAllListeners();
        });
};

PartialUploader.prototype.destroy = function () {
    if (this.client) {
        this.client.removeAllListeners();
    }

    this.client = null;
    this.file = null;
    this.ext = null;
    this.key = null;
    this.bucket = null;
    this.payLoadData = null; // 传给服务器的真实地址
    this.uploadedParts = null;
    this.uploadId = null;
    this.options = null;
};

module.exports = PartialUploader;
